/**
 * Copyright (c) 2020-2021 Perficient, Inc.
 * Unauthorized copying or distribution of this file prohibited without the express permission of Perficient.
 */

import React from "react";
import PhoneNumber from "awesome-phonenumber";
import PropTypes from "prop-types";
import { Box, TableCell, TableHead, TableRow, TableSortLabel, Checkbox } from "@material-ui/core";

export const getPhoneNormalized = (user) => {
	let phone =
		user.mobilePhone || (user.businessPhones && user.businessPhones.length > 0 ? user.businessPhones[0] : null);
	if (phone) {
		const pn = new PhoneNumber(phone);
		if (pn.isValid()) {
			phone = pn.getNumber(); // e164 by default
		} else {
			phone = "";
		}
	}
	return phone || "";
};

const headCells = [
	{ label: "Name", numeric: false, disablePadding: false, id: "displayName" },
	{ label: "Phone", numeric: false, disablePadding: false, id: "businessPhones" },
	{
		label: "Azure AD Group",
		numeric: false,
		disablePadding: false,
		id: "groups",
	},
	{ label: "Azure ID", numeric: false, disablePadding: false, id: "id" },
];

function AzureContactsTableHead(props) {
	const { onSelectAllClick, order, orderBy, numSelected, rowCount, onRequestSort } = props;
	const createSortHandler = (property) => (event) => {
		onRequestSort(event, property);
	};

	return (
		<TableHead>
			<TableRow>
				<TableCell padding="checkbox">
					<Checkbox
						indeterminate={numSelected > 0 && numSelected < rowCount}
						checked={rowCount > 0 && numSelected === rowCount}
						onChange={onSelectAllClick}
					/>
				</TableCell>
				{headCells.map((headCell) => (
					<TableCell
						key={headCell.id}
						align={headCell.numeric ? "right" : "left"}
						padding={headCell.disablePadding ? "none" : "normal"}
						sortDirection={orderBy === headCell.id ? order : false}
					>
						<TableSortLabel
							active={orderBy === headCell.id}
							direction={orderBy === headCell.id ? order : "asc"}
							onClick={createSortHandler(headCell.id)}
						>
							{headCell.label}
							{orderBy === headCell.id ? (
								<Box component="span" style={{ visibility: "hidden" }}>
									{order === "desc" ? "sorted descending" : "sorted ascending"}
								</Box>
							) : null}
						</TableSortLabel>
					</TableCell>
				))}
			</TableRow>
		</TableHead>
	);
}

AzureContactsTableHead.propTypes = {
	numSelected: PropTypes.number.isRequired,
	onRequestSort: PropTypes.func.isRequired,
	onSelectAllClick: PropTypes.func.isRequired,
	order: PropTypes.oneOf(["asc", "desc"]).isRequired,
	orderBy: PropTypes.string.isRequired,
	rowCount: PropTypes.number.isRequired,
};

export default AzureContactsTableHead;
